import { Component, Inject, Input } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigService,
    MaterialCheckModel,
} from '@evorait/pace-core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-material-availability-details',
    templateUrl: './material-availability-details.component.html',
    styleUrls: ['./material-availability-details.component.scss'],
})
export class MaterialAvailabilityDetailsComponent {
    @Input() public material: MaterialCheckModel;
    @Input() public responsePartSet: MaterialCheckModel[] = [];

    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public isCollapsed = true;
    public readonly showMaterialPricingInfo: boolean;
    public readonly showMaterialTSInfo: boolean;
    public readonly showMaterialNDFInfo: boolean;
    public constructor(
        public readonly modalInstance: BsModalRef,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
        private readonly configService: ConfigService,
    ) {
        this.showMaterialPricingInfo = this.clientManager.isNgmAP0();
        this.showMaterialTSInfo = !this.clientManager.isNgmAA();
        this.showMaterialNDFInfo = !this.clientManager.isNgmAA();
    }

    public displayMaterialNotAvailable(material: MaterialCheckModel): boolean {
        return material.available === 0 && this.clientManager.isNgmAA() && material.descTxt.length === 0;
    }
}
